import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    wrapper: {
        width: 400,
    },
    info_icon: {
        fontSize: "16px !important",
        cursor: "pointer",
    },
    container: {
        width: 320,
        height: 200,
        padding: "15px 10px",
        backgroundColor: "#fff",
        outline: "none",
        display: "flex",
        flexDirection: "column",
    },
    title: {
        paddingBottom: 0,
    },
    actions: {
        justifyContent: "flex-end",
    },
    checkbox_container: {
        justifyContent: "center",
    },
    footer_button: {
        margin: "0 10px",
    },
    item: {
        display: "flex",
        justifyContent: "space-between",
    },
    item_label: {
        fontSize: 16,
        fontWeight: 500,
        textTransform: "uppercase",
    },
}))
